import { Link } from "react-router-dom";
import { useScrollAnimation } from "../../../hooks/useScrollAnimation";
import { blogPosts } from "../../../mocks/homeData";

export default function Blog() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="blog" className="bg-white py-16 md:py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8" ref={ref}>
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <div
              className={`inline-block w-12 h-1 rounded-full bg-copper mb-4 ${
                isVisible ? "animate-fade-up" : "opacity-0"
              }`}
            />
            <h2
              className={`font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-navy ${
                isVisible ? "animate-fade-up" : "opacity-0"
              }`}
              style={{ animationDelay: "0.1s" }}
            >
              Güncel İçerikler
            </h2>
          </div>
          <Link
            to="/blog"
            className={`self-start sm:self-auto text-copper hover:text-copper-dark font-body text-sm font-medium inline-flex items-center gap-2 transition-colors whitespace-nowrap ${
              isVisible ? "animate-fade-up" : "opacity-0"
            }`}
            style={{ animationDelay: "0.2s" }}
          >
            Tüm Yazılar
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {blogPosts.map((post, index) => (
            <article
              key={post.id}
              className={`group bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-copper/20 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl ${
                isVisible ? "animate-fade-up" : "opacity-0"
              }`}
              style={{ animationDelay: `${0.15 + index * 0.1}s` }}
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4 bg-copper text-white font-body text-xs font-medium px-3 py-1.5 rounded-full">
                  {post.date}
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-bold text-base md:text-lg text-navy mb-3 line-clamp-2 group-hover:text-copper transition-colors duration-300">
                  {post.title}
                </h3>
                <p className="font-body text-sm text-gray-600 leading-relaxed mb-4 line-clamp-2">
                  {post.excerpt}
                </p>
                <button className="inline-flex items-center gap-2 font-body text-sm font-medium text-copper hover:text-copper-dark transition-colors group/link">
                  Devamını Oku
                  <div className="w-4 h-4 flex items-center justify-center group-hover/link:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line" />
                  </div>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}